import React, { Component } from 'react';
import { Button, Popover } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import TableC from '../../basicElement/TableC';
import format from '../../shared/format';
import moment from 'moment';

class Filter extends Component {
    render() {
        const { endMonth, startMonth, ...rest } = this.props;
        const filters = [{
            name: '合同收入确认时间',
            key: 'date',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
                disabledDate: current => current && (current.valueOf() < moment(startMonth).valueOf() || current.valueOf() > moment(endMonth).valueOf())
            }
            // name: '合同收入确认时间',
            // key: 'date',
            // type: 'monthPickerRange',
            // typeProperty: {
            //     allowClear: false,
            //     keys: ['dateStart', 'dateEnd'],
            //     style:{position:"relative",top:"-5px"}
            // }
        }, {
            name: 'JDE主项目号',
            key: 'jdeMainCode',
            type: 'input',
        }, {
            name: 'JDE项目号',
            key: 'jdeCode',
            type: 'input',
        }];
        return <FilterBasic filters={filters} {...rest} />;
    }
}

class FailureRecord extends Component {
    constructor(props) {
        super(props);
        const { date } = props;
        this.state = {
            data: [],
            loading: false,
            sortParams: {},
            curParams: { date },
            searchParams: { date },
            pagination: {
                pageSize: 10,
                current: 1,
            },
            endMonth: '',
            startMonth: '',
        };
    }

    componentDidMount() {
        this.queryFixedLineTime();
    }

    queryFixedLineTime = () => {
        Fetch.post(API_URL.finance.queryFixedLineTime).then(res => {
            const { data } = res;
            const startMonth = moment(format('month', data[0].year, data[0].month)).format('YYYY-MM');
            const endMonth = moment(format('month', data[data.length - 1].year, data[data.length - 1].month)).format('YYYY-MM');
            this.setState({
                endMonth,
                startMonth,
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        Fetch.post(API_URL.finance.queryFailRecordList, {
            type: 'PREPAID',
            offset: current,
            limit: pageSize,
            ...sortParams,
            ...curParams,
        }).then(res => {
            const { datas, totalCount } = res;
            pagination.total = totalCount;
            this.setState({
                loading: false,
                data: datas,
                pagination,
            });
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false });
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {...searchParams},
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.finance.exportFailRecordList;
        ExportUtil.export({ ...sortParams, ...curParams }, null, url);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    handleStringLinefeed = (text) => {
        const arr = (text || '').split(',');
        const result = arr.map((item, index) => {
            return <span key={index}>{item}{index < arr.length - 1 ? ',' : ''}<br /></span>;
        });
        return result;
    }

    getColumns = () => {
        const columns = [{
            title: '失败原因',
            dataIndex: 'errorMessage',
            key: 'errorMessage',
            fixed: 'left',
            width: 120,
        }, {
            title: 'JDE项目号',
            dataIndex: 'jdeCode',
            key: 'jdeCode',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'jdeMainCode',
            key: 'jdeMainCode',
            width: 120,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusinessName',
            key: 'lineOfBusinessName',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineNames',
            key: 'secondLineNames',
            width: 100,
        }, {
            title: '合同签署单位',
            dataIndex: 'signingUnit',
            key: 'signingUnit',
            width: 100,
        }, {
            title: '收入归属单位',
            dataIndex: 'belongingToUnit',
            key: 'belongingToUnit',
            width: 100,
        }, {
            title: '名称(Project ID)',
            dataIndex: 'projectIdName',
            key: 'projectIdName',
            width: 120,
        }, {
            title: '计收入确认方式',
            dataIndex: 'contractTypeValue',
            key: 'contractTypeValue',
            width: 80
        }, {
            title: '发票税率',
            dataIndex: 'invoiceRate',
            key: 'invoiceRate',
            width: 80,
            render: (text) => format('unit', text, '%'),
        }, {
            title: '汇率',
            dataIndex: 'exchangeRate',
            key: 'exchangeRate',
            width: 80,
        }, {
            title: '合同是否签署完成',
            dataIndex: 'contractIsSigned',
            key: 'contractIsSigned',
            width: 80,
            render: text => text ? text === "1" ? "是" : "否" : '',
        }, {
            title: '合同性质',
            dataIndex: 'contractNatureShow',
            key: 'contractNatureShow',
            width: 80,
        }, {
            title: 'JDE发号时间',
            dataIndex: 'distributeTime',
            key: 'distributeTime',
            width: 90,
            render: text => format('date', text),
        }, {
            title: 'PM工号',
            dataIndex: 'mainPmUserCode',
            key: 'mainPmUserCode',
            width: 80,
        }, {
            title: 'PM姓名',
            dataIndex: 'mainPmUserName',
            key: 'mainPmUserName',
            width: 80,
        }, {
            title: 'BD工号',
            dataIndex: 'bdCodes',
            key: 'bdCodes',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: 'BD姓名',
            dataIndex: 'bdNames',
            key: 'bdNames',
            width: 80,
            render: this.handleStringLinefeed,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 160,
        }, {
            title: '项目阶段',
            dataIndex: 'investigationStageNames',
            key: 'investigationStageNames',
            width: 90,
        }, {
            title: '研究产品类型',
            dataIndex: 'investigationMedicineTypeValue',
            key: 'investigationMedicineTypeValue',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'investigationByStageName',
            key: 'investigationByStageName',
            width: 90,
        }, {
            title: '受试者类型',
            dataIndex: 'testeeTypeName',
            key: 'testeeTypeName',
            width: 80,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '项目领域',
            dataIndex: 'invAreaShow',
            key: 'invAreaShow',
            width: 80,
        }, {
            title: '项目编号',
            dataIndex: 'investigationCode',
            key: 'investigationCode',
            width: 80,
        }, {
            title: '客户JDE号',
            dataIndex: 'customerJdeCode',
            key: 'customerJdeCode',
            width: 90,
        }, {
            title: '客户全名',
            dataIndex: 'customerCompanyName',
            key: 'customerCompanyName',
            width: 100,
        }, {
            title: '申办方',
            dataIndex: 'sponsorName',
            key: 'sponsorName',
            width: 100,
        }, {
            title: '合同开始时间',
            dataIndex: 'contractStartTime',
            key: 'contractStartTime',
            width: 90,
            render: text => format('date', text),
        }, {
            title: '合同结束时间',
            dataIndex: 'contractEndTime',
            key: 'contractEndTime',
            width: 90,
            render: text => format('date', text),
        }, {
            title: '合同中是否明标合同金额',
            dataIndex: 'contractIsSpecifiesAmount',
            key: 'contractIsSpecifiesAmount',
            width: 90,
            render: text => text ? text === "1" ? "是" : "否" : '',
        }, {
            title: '币种',
            dataIndex: 'currencyName',
            key: 'currencyName',
            width: 100,
        }, {
            title: '合同额含税/原币',
            dataIndex: 'initialContractAmount',
            key: 'initialContractAmount',
            width: 100,
            render: text => format('money', text),
        }, {
            title: '合同额含税/人民币（元）',
            dataIndex: 'cnyContractAmount',
            key: 'cnyContractAmount',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/原币',
            dataIndex: 'initialActualExpenseFee',
            key: 'initialActualExpenseFee',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/原币',
            dataIndex: 'initialActualFee',
            key: 'initialActualFee',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '合同额税费/原币',
            dataIndex: 'initialTaxationFee',
            key: 'initialTaxationFee',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '实报实销(不含税)/人民币(元)',
            dataIndex: 'cnyActualExpenseFee',
            key: 'cnyActualExpenseFee',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '实报实销税费/人民币',
            dataIndex: 'cnyActualFee',
            key: 'cnyActualFee',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '合同额税费/人民币（元）',
            dataIndex: 'cnyTaxationFee',
            key: 'cnyTaxationFee',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '合同税率',
            dataIndex: 'rate',
            key: 'rate',
            width: 90,
            render: (text) => format('unit', text, '%'),
        }, {
            title: 'FTE单价(含税)(元)',
            dataIndex: 'fteUnitPrice',
            key: 'fteUnitPrice',
            width: 90,
            render: text => format('money', text),
        }, {
            title: '涉及中心',
            dataIndex: 'siteNameCodes',
            key: 'siteNameCodes',
            width: 120,
            render: (value, record, index) => {
                const { siteNameCodes } = record;
                const siteNameList = (siteNameCodes || '').split(';');
                if (siteNameList.length > 1) {
                    return (
                        <div style={{textAlign:"left"}}>
                            <Popover
                                placement="bottomRight"
                                overlayClassName="contract-pop"
                                content={
                                   <div style={{color:"#333e4d"}} >
                                        {
                                            siteNameList.map((value,index) => <div key={index}>{value}</div>)
                                        }
                                    </div>  
                                }
                                trigger="hover"
                            >
                                <i className='pop' style={{cursor: 'pointer'}}></i>
                            </Popover>
                            <div className='pop-div'>{siteNameList[0]}</div>
                        </div >
                    );
                }else if(siteNameList.length==1){
                    return (
                        <div style={{textAlign:"left"}}>
                            <div className='pop-div'>{siteNameList[0]}</div>
                        </div >
                    );
                }
                return '';
            },
        }];
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, searchParams, endMonth, startMonth } = this.state;
        // const{serParams={}}=this.props;
        // searchParams.date=serParams&&serParams.dateEnd;
        return (
            <div className="main">
                 <div>
                    <i
                        className="icon iconfont"
                        style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                    >&#xe65b;</i>
                    失败记录
                </div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    endMonth={endMonth}
                    startMonth={startMonth}
                    onChange={this.handleFilterChange}
                    buttons={[
                        <Button
                            key="back"
                            type="primary"
                            onClick={() => this.props.showFailureRecord(false)}
                            style={{ marginLeft: 8, background: '#62cf96', border: '1px solid #00a854' }}
                        >返回</Button>
                    ]}
                />
                <TableC
                    data={data}
                    loading={loading}
                    className="commentLog"
                    columns={this.getColumns()}
                    rowKey="investigationJdeContractFailRecordId"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
            </div>
        );
    }
}

export default FailureRecord;


// WEBPACK FOOTER //
// ./src/components/financeManagement/otherChargesReport/FailureRecord.js